var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 16C31.5 7.437 24.562.5 16 .5 7.437.5.5 7.438.5 16c0 7.736 5.668 14.149 13.078 15.313V20.48H9.641V16h3.937v-3.415c0-3.884 2.313-6.03 5.855-6.03 1.696 0 3.47.303 3.47.303v3.812h-1.955c-1.925 0-2.526 1.195-2.526 2.42V16h4.299l-.688 4.48h-3.611v10.832C25.832 30.15 31.5 23.736 31.5 16Z"
})));
export default SvgFacebook;